export const partnerTermsMetadata = {
  policyKey: "ONEGRAD_PARTNER_TERMS",
  policyVersion: "1.0",
  effectiveDate: "2024-11-18",
  effectiveDateDisplay: "Nov 18, 2024",
  documentUrl: "/partner-terms",
};

export const partnerTermsSections = [
  {
    title: "Company",
    body: "OneGrad LLC, 43 Magnolia Dr, Hopkinton, MA 01748",
  },
  {
    title: "1. Acceptance",
    body: "By registering as a Partner on partner.onegrad.ai, you agree to these Partner Terms.",
  },
  {
    title: "2. Independent Contractor Status",
    body: "You are an independent contractor. Nothing in this Agreement creates employment, agency, partnership, or joint venture.",
  },
  {
    title: "3. Representations & Warranties",
    body: "You represent that your credentials are accurate, you are legally permitted to provide advisory services, you will not guarantee admissions or visa approvals, and you comply with applicable laws.",
  },
  {
    title: "4. Prohibited Conduct",
    body: "You may not: provide unauthorized legal advice; guarantee admission outcomes; solicit students off-platform; collect payments outside the Platform; misuse student data; engage in harassment or discrimination.",
  },
  {
    title: "5. Payments & Fees",
    body: "Payments are processed via Stripe Connect. OneGrad collects payments, deducts platform fees, and remits the balance. You are responsible for taxes and local compliance.",
  },
  {
    title: "6. Confidentiality",
    body: "You agree to protect student information, use data only for Platform services, and not store data outside approved systems.",
  },
  {
    title: "7. Data Protection",
    body: "You must comply with applicable data protection laws and implement reasonable safeguards.",
  },
  {
    title: "8. Termination",
    body: "OneGrad may suspend or terminate your account for misrepresentation, complaints, fraud, or legal risk.",
  },
  {
    title: "9. Limitation of Liability",
    body: "OneGrad is not liable for loss of income, student disputes, or third-party claims. Liability is capped at fees earned in the prior 12 months.",
  },
  {
    title: "10. Indemnification",
    body: "You agree to indemnify OneGrad for claims arising from your advice, misconduct, or regulatory violations.",
  },
  {
    title: "11. Dispute Resolution",
    body: "Disputes are resolved by binding arbitration in Massachusetts, USA. Class actions are waived.",
  },
  {
    title: "12. Governing Law",
    body: "Massachusetts, USA.",
  },
];

export const partnerTermsText = [
  "OneGrad Partner Terms",
  `Effective Date: ${partnerTermsMetadata.effectiveDate}`,
  `Version: ${partnerTermsMetadata.policyVersion}`,
  ...partnerTermsSections.flatMap((section) => [section.title, section.body]),
].join("\n");
